// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3rzNv","cell":"ColumnAccessor_cell__3AWmh","firstCellAccent":"ColumnAccessor_firstCellAccent__EbSWB"};